import {PersonSelectorProps, personType} from "@ots-frontend/ots-data";
import {PersonMultiSelect, PersonMultiSelectProps} from "./PersonMultiSelect";

export type DriverMultiSelectProps = PersonMultiSelectProps & {
  selector?: Omit<PersonSelectorProps, 'personType'>
}

export const DriverMultiSelect = (props: DriverMultiSelectProps) => {
  const {selector, ...rest} = props;
  return (
    <PersonMultiSelect
      {...rest}
      selector={{
        ...selector,
        personType: personType.driver,
      }}
    />
  );
};
